export default "__VITE_ASSET__73139ef4__"